import {Toast} from "@/hooks/useToast.ts";
import React from "react";
import {ToastComponent} from "@/components/ui/ToastComponent.tsx";

interface ToastContainerProps {
    toasts: Toast[];
    removeToast: (id: string) => void;
    position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center';
}

export const ToastContainer: React.FC<ToastContainerProps> = ({
                                                                  toasts,
                                                                  removeToast,
                                                                  position = 'top-right'
                                                              }) => {
    const getPositionStyles = () => {
        switch (position) {
            case 'top-right':
                return 'fixed top-4 right-4 z-50';
            case 'top-left':
                return 'fixed top-4 left-4 z-50';
            case 'bottom-right':
                return 'fixed bottom-4 right-4 z-50';
            case 'bottom-left':
                return 'fixed bottom-4 left-4 z-50';
            case 'top-center':
                return 'fixed top-4 left-1/2 transform -translate-x-1/2 z-50';
            case 'bottom-center':
                return 'fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50';
            default:
                return 'fixed top-4 right-4 z-50';
        }
    };

    if (toasts.length === 0) return null;

    return (
        <div className={`${getPositionStyles()} space-y-2`}>
            {toasts.map((toast) => (
                <ToastComponent
                    key={toast.id}
                    toast={toast}
                    onRemove={removeToast}
                />
            ))}
        </div>
    );
};